function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class Collapsible {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		const scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		const contentSelectorIsId =
			this.options.contentSelector &&
			this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[
				this.options.contentSelectorScope
			]
				? scopes[this.options.contentSelectorScope]
				: scopes["element"];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector
			? this.element.querySelector(this.options.buttonSelector)
			: this.element;

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content =
			this.options.contentSelector &&
			this.contentSelectorScope.querySelector(
				this.options.contentSelector
			);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";
		this.collapsedClass = this.options.collapsedClass;

		this.toggleMethod =
			this.collapseWith === "class"
				? this.toggleWithClass
				: this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		this.bindDocumentEvents = this.options.closeWithDocumentClick
			? this.bindDocumentClick
			: function() {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick
			? this.unbindDocumentClick
			: function() {};

		this.init();
		this.watch();
	}

	init() {
		// component enabled - show the button
		this.button.hidden = false;

		// Determine initial collapse state
		//	if set open option determines init state
		var doCollapse =
			this.options.open !== undefined ? !this.options.open : true;

		this.toggleMethod(doCollapse);
		this.isCollapsed = doCollapse;
	}

	watch() {
		this.button.addEventListener("click", this.toggle.bind(this));
		this.attributeObserver.observe(this.element, { attributes: true });
	}

	toggleWithHidden(doCollapse) {
		this.button.setAttribute("aria-expanded", !doCollapse);

		if (!this.content) {
			return false;
		}
		this.content.hidden = doCollapse;
	}

	toggleWithClass(doCollapse) {
		this.button.setAttribute("aria-expanded", !doCollapse);

		if (!this.content) {
			return false;
		}
		if (doCollapse) {
			this.content.classList.add(this.collapsedClass);
		} else {
			this.content.classList.remove(this.collapsedClass);
		}
	}

	// button click handler
	toggle() {
		if (!this.options.selfClosing && !this.isCollapsed) {
			return false;
		}

		const handler = this.isCollapsed
			? this.open.bind(this)
			: this.close.bind(this);
		handler();
	}

	open() {
		this.toggleMethod(false);
		this.isCollapsed = false;
		this.element.dataset.collapsibleOpen = true;
		this.bindDocumentEvents();
	}

	close() {
		this.toggleMethod(true);
		this.isCollapsed = true;
		this.element.dataset.collapsibleOpen = false;
		this.unbindDocumentEvents();
	}

	bindDocumentClick() {
		document.addEventListener("click", this.onDocumentClick.bind(this));
	}

	unbindDocumentClick() {
		document.removeEventListener("click", this.onDocumentClick);
	}

	onDocumentClick(event) {
		const clickTarget = event.target;

		// clicked this.button
		if (clickTarget === this.button || this.button.contains(clickTarget)) {
			return false;
		}

		// clicked this.content
		if (
			this.content &&
			(clickTarget === this.content || this.content.contains(clickTarget))
		) {
			return false;
		}

		this.close();
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter(mutation => {
				return (
					mutation.type === "attributes" &&
					mutation.attributeName.startsWith("data-collapsible-open")
				);
			})
			.forEach(this.onOpenChanged.bind(this));
	}

	onOpenChanged(mutation) {
		const doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
		if (this.isCollapsed !== doCollapse) {
			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}
}

Collapsible.DEFAULTS = {
	selfClosing: true
};

export default Collapsible;



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__collapsible/collapsible.js